import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { right } from '@popperjs/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { SecurityService } from '../../services/security.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { GenericResponseDto, Gruppo, Tendina, UserCreateDto, ValidationDto } from './gestione-utenti.costants';
import { ButtonsGestioneUtentiComponent } from './buttons-gestione-utenti/buttons-gestione-utenti.component';
import { BillingAccount, DataCustomerBOperator, DataCustomerCountry, DataCustomerLeadOperator } from '../customer-data-entry/save/creazione-nuovo-customer/creazione-nuovo-customer-costants';
import { UsersManagementService } from 'src/app/FASWhiteLabelPortal/services/users-management.service';
import { UserCreationBillingAccountsOutputDto } from 'src/app/FASWhiteLabelPortal/models/user.model';
import { create } from 'domain';

@Component({
  selector: 'app-gestione-utenti',
  templateUrl: './gestione-utenti.component.html',
  styleUrls: ['./gestione-utenti.component.css']
})
export class GestioneUtentiComponent implements OnInit, OnDestroy {

  settings = {
    actions: {

      add: false,
      edit: false,
      delete: false,
      position: right
    },
    columns: {
      nome: {
        title: 'Name'
      },
      cognome: {
        title: 'Surname'
      },
      username: {
        title: 'Username'
      },
      email: {
        title: 'E-mail'
      },
      phoneNumber: {
        title: 'Phone Number'
      },
      singleGroupUserFe: {
        title: 'Group',
        valuePrepareFunction: (value: string) => {
          let groupName = value;
          if (groupName === 'BACK_OFFICE_AGENT') groupName = 'OPERATOR AGENT';
          if (groupName === 'BACK_OFFICE_ADMIN') groupName = 'OPERATOR ADMIN';
          if (groupName === 'FLEET_MANAGER') groupName = 'FLEET MANAGER';
          if (groupName === 'FLEET_MANAGER_ADMIN') groupName = 'FLEET MANAGER ADMIN';
          if (groupName === 'ADMIN_FREEMOVE_FE') groupName = 'ADMIN FREEMOVE FE';
          return groupName
        }
      },
      button: {
        title: 'Actions',
        type: 'custom',
        renderComponent: ButtonsGestioneUtentiComponent,
        filter: false,
        onComponentInitFunction: (instance: any) => {
          instance.openDeleteModalEvent
            .subscribe((data: any) => {
              this.openDeleteModal(data);
            });
          instance.openUpdateModalEvent
            .subscribe((data: any) => {
              this.openUpdateModal(data);
            })
        }
      }
    },
    pager: {
      display: false
    }
  };

  listUtenti: any[] = [];
  aggiungiUtenteForm: FormGroup;
  updateUtenteForm: FormGroup;
  userToDelete: string = "";
  listUsersResponse: any;
  tendinaGruppi: Tendina[] = [];
  listCustomerView: any[] = [];
  createCustomerDto: DataCustomerLeadOperator;
  elementSelected: DataCustomerLeadOperator;
  regexPassword: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})";

  regexMail: string = "^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$";

  regexPhoneNumber: string = "^(\\+\\d{1,3}( )?)?((\\(\\d{1,3}\\))|\\d{1,3})[- .]?\\d{3,4}[- .]?\\d{4}$";

  @ViewChild('confirmElimina') confirmEliminaModal: NgbModalRef;
  @ViewChild('updateUtente') updateUtenteModal: NgbModalRef;
  @ViewChild('confirmSave') confirmSaveModal: NgbModalRef;
  @ViewChild('aggiungiUtente') aggiungiUtenteModal: NgbModalRef;
  @ViewChild('changePasswordPopup') changePasswordModal: NgbModalRef;

  destroy$ = new Subject<boolean>();

  listGroupsResponse: any;
  listGruppi: Gruppo[] = [];
  validationAddUserResponse: ValidationDto;

  modalReference: NgbModalRef;
  modalReferenceUpdateModal: NgbModalRef;

  userCreateDto: UserCreateDto;

  saveUserResponse: GenericResponseDto;

  deleteUserResponse: GenericResponseDto;

  userNameUpdateModal: string = '';
  userCreateUpdateModal: string = '';
  userLastUpdateUpdateModal: string = '';
  userDataInsUpdateModal: string = '';
  userLastUpdateDateUpdateModal: string = '';

  updateUserResponse: GenericResponseDto;

  groupUpdateModalDisable: boolean = false;

  changePasswordForm: FormGroup;

  //white portal methods

  listOperatorView: any[] = [];


  billingTableData: any[] = [];
  billingTableLO: any[] = [];
  billingTableDataRecord: Record<string, any[]> = {};
  billingTableLORecord: Record<string, any[]> = {};

  constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private networkService: NetworkService,
    private securityService: SecurityService, private toastr: ToastrManager, private spinner: NgxSpinnerService, private usersManagementService: UsersManagementService,) { }

  ngOnInit(): void {
    this.loadListUsers();
    this.loadGroups();
    this.loadOperators(); // Load operators for the dropdown

  }

  loadListUsers() {
    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllUsers;
    let data = {}
    data = Utility.createBodyForPostRequest(data);
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listUtenti = JSON.parse(response.body);
            this.spinner.hide("sp1");

          } else {
            this.toastr.errorToastr('Error during Retrieve Users', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.spinner.hide("sp1");
          }
        }
        else {
          if (response && Array.isArray(response)) {
            this.listUtenti = response;
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {

            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Retrieve Users', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          console.error(err);
          this.toastr.errorToastr('Error during Retrieve Users', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        });;
  }

  onCustomAction(event: any) {
    switch (event.action) {
      case 'deleteAction':
        this.openDeleteModal(event.data);
        break;
      case 'editAction':
        this.openUpdateModal(event.data);
        break;

    }
  }

  openDeleteModal(elemToDelete: any) {
    this.userToDelete = elemToDelete.username;
    let modalRef = this.modalService.open(this.confirmEliminaModal, { size: 'sm' });
    modalRef.result.then((result) => {
      if (result) {
        this.deletUser(this.userToDelete);
      } else {
      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  openUpdateModal(elemToUpdate: any) {
    let user: any = this.securityService.getUser();
    this.usersManagementService.getUser({ username: elemToUpdate.username }).subscribe(
      (response) => {
        let elemToUpdate: any;
        if (this.networkService.checkEnvironmentIsDev()) {
          elemToUpdate = JSON.parse(response.body);
        }else{
          elemToUpdate = response;
        }
        this.updateUtenteForm = this.formBuilder.group({
          nome: [elemToUpdate.nome, [Validators.required]],
          mail: [elemToUpdate.email, [Validators.required]],
          cognome: [elemToUpdate.cognome, [Validators.required]],
          username: [elemToUpdate.username, [Validators.required]],
          password: ['', []], // password is not required for update, but keep field for consistency
          confirmPassword: ['', []],
          phoneNumber: [elemToUpdate.phoneNumber, [Validators.required]],
          userCreate: [elemToUpdate.userCreate],
          userUpdate: [user],
          group: [elemToUpdate.userGroup || elemToUpdate.singleGroupUserFe || '', [Validators.required]],
          operator: [elemToUpdate.operator || ''],
          customer: [this.ensureArray(elemToUpdate.customersId)],
          billingAccount: [this.ensureArray(elemToUpdate.billingAccount)],
          billingAccountLO: [this.ensureArray(elemToUpdate.billingAccountLO)]
        });
        this.userNameUpdateModal = elemToUpdate.username;
        this.userCreateUpdateModal = elemToUpdate.userCreate;
        this.userLastUpdateUpdateModal = elemToUpdate.userUpdate;
        this.userDataInsUpdateModal = elemToUpdate.dataInsAsString;
        this.userLastUpdateDateUpdateModal = elemToUpdate.dataModAsString;
        this.groupDisabledForUpdate();
        // Ensure operator dropdown is populated and selected
        if (elemToUpdate.operator) {
          this.initializeListCustomerUpdate( elemToUpdate.operator, elemToUpdate);
        }
        this.modalReferenceUpdateModal = this.modalService.open(this.updateUtenteModal, { size: 'lg' });
        this.modalReferenceUpdateModal.result.then((result) => {
          if (result) {
            console.log("ok")
            if (this.isModificaNecessaria(this.updateUtenteForm, elemToUpdate)) {
              if (this.validaUpdateUtente()) {
                this.openConfirmUpdateModal(elemToUpdate);
              }
            } else {
              this.toastr.errorToastr('No fields have been changed. No update needed!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });
            }
          } else {
          }
        }, (reason) => {
          /*Leave empty or handle reject*/
        });
      },
      (err) => {
        console.error(err);
        this.toastr.errorToastr('Error during user retrieval', 'Error', {
          animate: 'slideFromRight',
          timeout: '3000',
        });
      }
    );


  }

  isModificaNecessaria(form: FormGroup, elem: any): boolean {
    let result: boolean = false;
    if (form && elem) {
      if (
        form.controls['nome'].value != elem.nome ||
        form.controls['cognome'].value != elem.cognome ||
        form.controls['mail'].value != elem.mail ||
        form.controls['phoneNumber'].value != elem.phoneNumber ||
        form.controls['group'].value != elem.singleGroupUserFe ||
        form.controls['operator']?.value != elem.operator ||
        JSON.stringify(form.controls['customer']?.value) != JSON.stringify(elem.customersId) ||
        JSON.stringify(form.controls['billingAccount']?.value) != JSON.stringify(elem.boBillingAccounts) ||
        JSON.stringify(form.controls['billingAccountLO']?.value) != JSON.stringify(elem.loBillingAccounts)
      ) {
        result = true;
      }

    }
    return result;
  }

  openConfirmSaveModal() {

    let modalRef = this.modalService.open(this.confirmSaveModal, { size: 'sm' });
    modalRef.result.then((result) => {
      if (result) {
        this.signUpUser();
      } else {

      }
    }, (reason) => {



    });
  }

  openConfirmUpdateModal(elemToUpdate: any) {

    let modalRef = this.modalService.open(this.confirmSaveModal, { size: 'sm' });
    modalRef.result.then((result) => {
      if (result) {
        this.updateUtente(elemToUpdate);
      } else {

      }
    }, (reason) => {



    });
  }

  openAggiungiUtenteModal() {
    this.listCustomerView = [];
    this.billingTableData = [];
    this.billingTableLO = [];
    let user: any = this.securityService.getUser();
    this.aggiungiUtenteForm = this.formBuilder.group({
      nome: ['', [Validators.required]],
      mail: ['', [Validators.required]],
      cognome: ['', [Validators.required]],
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      userCreate: [user],
      group: ['', [Validators.required]],
    });
    this.modalReference = this.modalService.open(this.aggiungiUtenteModal, { size: 'lg' });
    this.modalReference.result.then((result) => {
      if (result) {
        this.openConfirmSaveModal();
      } else {
      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  loadGroups() {
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllGroups;
    let data = {
      body: ''
    }
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listGroupsResponse = JSON.parse(response.body);
            this.listGruppi = this.listGroupsResponse.groups;
            if (this.listGruppi && this.listGruppi.length > 0) {
              this.tendinaGruppi = [];
              for (var _i = 0; _i < this.listGruppi.length; _i++) {
                let item: Tendina = {
                  etichetta: this.listGruppi[_i].description,
                  valore: this.listGruppi[_i].groupName
                };
                this.tendinaGruppi.push(item);
              }
              this.tendinaGruppi.map(item => {
                 let groupName = item.valore;
                 item.etichetta = item.valore;
                if (groupName === 'BACK_OFFICE_AGENT') item.etichetta = 'OPERATOR AGENT';
                if (groupName === 'BACK_OFFICE_ADMIN') item.etichetta = 'OPERATOR ADMIN';
                if (groupName === 'FLEET_MANAGER') item.etichetta = 'FLEET MANAGER';
                if (groupName === 'FLEET_MANAGER_ADMIN') item.etichetta = 'FLEET MANAGER ADMIN';
                if (groupName === 'ADMIN_FREEMOVE_FE') item.etichetta = 'ADMIN FREEMOVE FE';
                return item
              })
            }

          } else {
            this.toastr.errorToastr('Error during Retrieve Groups', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {
          if (response && response.groups) {
            this.listGroupsResponse = response;
            this.listGruppi = this.listGroupsResponse.groups;
            if (this.listGruppi && this.listGruppi.length > 0) {
              this.tendinaGruppi = [];
              for (var _i = 0; _i < this.listGruppi.length; _i++) {
                let item: Tendina = {
                  etichetta: this.listGruppi[_i].description,
                  valore: this.listGruppi[_i].groupName
                };
                this.tendinaGruppi.push(item);
              }
              this.tendinaGruppi.map(item => {
                 let groupName = item.valore;
                 item.etichetta = item.valore;
                if (groupName === 'BACK_OFFICE_AGENT') item.etichetta = 'OPERATOR AGENT';
                if (groupName === 'BACK_OFFICE_ADMIN') item.etichetta = 'OPERATOR ADMIN';
                if (groupName === 'FLEET_MANAGER') item.etichetta = 'FLEET MANAGER';
                if (groupName === 'FLEET_MANAGER_ADMIN') item.etichetta = 'FLEET MANAGER ADMIN';
                if (groupName === 'ADMIN_FREEMOVE_FE') item.etichetta = 'ADMIN FREEMOVE FE';
                return item
              })
            }
          } else if (response && response.length && response.length > 0) {

            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            console.log(response);
            this.toastr.errorToastr('Error during Retrieve Groups', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          console.error(err);
          this.toastr.errorToastr('Error during Retrieve Groups', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        });
  }

  validaAggiungiUtente(): boolean {
    let result = true;
    if (this.aggiungiUtenteForm.controls['password'].value != this.aggiungiUtenteForm.controls['confirmPassword'].value) {
      this.toastr.errorToastr('Password and Confirm Password do not match!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });
      return false;
    }
    let regex = new RegExp(this.regexMail);
    if (!regex.test(this.aggiungiUtenteForm.controls['mail'].value)) {
      this.toastr.errorToastr('Wrong email format!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });
      return false;
    }
    let regexPass = new RegExp(this.regexPassword);
    if (!regexPass.test(this.aggiungiUtenteForm.controls['password'].value)) {
      this.toastr.errorToastr('The password must contain at least 8 characters, one uppercase character, one lowercase character, one number and one special character!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }

    let regexPhone = new RegExp(this.regexPhoneNumber);
    if (!regexPhone.test(this.aggiungiUtenteForm.controls['phoneNumber'].value)) {
      this.toastr.errorToastr('The phone number do not have the international format!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    return result;
  }

  addFormDisabled() {
    return this.aggiungiUtenteForm?.invalid;
  }

  addUtente() {
    if (this.validaAggiungiUtente()) {
      if (this.isNewRole()) {
        this.modalReference.close(true);
        return;
      }


      let urlValidation: string = environment.basePath + _ENDPOINT.validationAddUser;
      this.createUserCreateDto();
      let data = Utility.createBodyForPostRequest(this.userCreateDto);
      this.spinner.show("sp1");
      this.networkService.post(urlValidation, data)
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {

          if (this.networkService.checkEnvironmentIsDev()) {
            if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
              this.validationAddUserResponse = JSON.parse(response.body);
              if (this.validationAddUserResponse && this.validationAddUserResponse.esito == 'OK') {
                this.spinner.hide("sp1");
                this.modalReference.close(true);

              } else if (this.validationAddUserResponse && this.validationAddUserResponse.esito == 'KO') {
                this.spinner.hide("sp1");
                this.toastr.errorToastr(this.validationAddUserResponse.errorMessage, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

              }

            } else {
              this.spinner.hide("sp1");
              this.toastr.errorToastr('Error during the save validation!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

            }
          }
          else {

            if (response && response.esito) {
              this.validationAddUserResponse = response;
              if (this.validationAddUserResponse && this.validationAddUserResponse.esito == 'OK') {
                this.spinner.hide("sp1");
                this.modalReference.close(true);

              } else if (this.validationAddUserResponse && this.validationAddUserResponse.esito == 'KO') {
                this.spinner.hide("sp1");
                this.toastr.errorToastr(this.validationAddUserResponse.errorMessage, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

              }
            } else if (response && response.length && response.length > 0) {
              this.spinner.hide("sp1");
              console.log(response);
              this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide("sp1");
              console.log(response);
              this.toastr.errorToastr('Error during save validation', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }

          }

        },
          err => {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save validation!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            console.log(err);
          });;


    }

  }

  createUserCreateDto() {
    const customers = this.ensureArray(this.aggiungiUtenteForm.controls['customer']?.value);
    if (this.isNewRole()) {
      var data: UserCreateDto = {
        nome: this.aggiungiUtenteForm.controls['nome'].value,
        mail: this.aggiungiUtenteForm.controls['mail'].value,
        cognome: this.aggiungiUtenteForm.controls['cognome'].value,
        username: this.aggiungiUtenteForm.controls['username'].value,
        password: this.aggiungiUtenteForm.controls['password'].value,
        confirmPassword: this.aggiungiUtenteForm.controls['confirmPassword'].value,
        phoneNumber: this.aggiungiUtenteForm.controls['phoneNumber'].value,
        userCreate: this.aggiungiUtenteForm.controls['userCreate'].value,
        group: this.aggiungiUtenteForm.controls['group'].value,
        loBillingAccounts: this.aggiungiUtenteForm.controls['billingAccountLO'].value,
        boBillingAccounts: this.aggiungiUtenteForm.controls['billingAccount']?.value || [],
        flBillingAccounts: this.aggiungiUtenteForm.controls['billingAccountLO'].value,
        customerNames: customers,
        customersId: customers,
        leadOperatorId: this.aggiungiUtenteForm.controls['operator'].value,
        operator: this.aggiungiUtenteForm.controls['operator'].value
      }
    } else {
      var data: UserCreateDto = {
        nome: this.aggiungiUtenteForm.controls['nome'].value,
        mail: this.aggiungiUtenteForm.controls['mail'].value,
        cognome: this.aggiungiUtenteForm.controls['cognome'].value,
        username: this.aggiungiUtenteForm.controls['username'].value,
        password: this.aggiungiUtenteForm.controls['password'].value,
        confirmPassword: this.aggiungiUtenteForm.controls['confirmPassword'].value,
        phoneNumber: this.aggiungiUtenteForm.controls['phoneNumber'].value,
        userCreate: this.aggiungiUtenteForm.controls['userCreate'].value,
        group: this.aggiungiUtenteForm.controls['group'].value
      }
    }
    this.userCreateDto = data;
  }

  signUpUser() {
    let urlSignUpUser: string = environment.basePath + _ENDPOINT.signUpUser;
    this.createUserCreateDto();

    let data = Utility.createBodyForPostRequest(this.userCreateDto);
    this.spinner.show("sp1");
    this.networkService.post(urlSignUpUser, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.saveUserResponse = JSON.parse(response.body);
            if (this.saveUserResponse && this.saveUserResponse.status == 'OK') {
              this.spinner.hide("sp1");
              this.toastr.successToastr('User added successfully!', 'User added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.saveUserResponse && this.saveUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.saveUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }

        }
        else {
          if (response && response.status) {
            this.saveUserResponse = response;
            if (this.saveUserResponse && this.saveUserResponse.status == 'OK') {
              this.spinner.hide("sp1");
              this.toastr.successToastr('User added successfully!', 'User added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.saveUserResponse && this.saveUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.saveUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr('Error during the save user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }

      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the save user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          console.error(err);



        });

  }

  deletUser(username: string) {
    this.spinner.show("sp1");
    let urlDeleteUser: string = environment.basePath + _ENDPOINT.deleteUser;

    let data = Utility.createBodyForPostRequest(username,true);
    this.networkService.post(urlDeleteUser, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.deleteUserResponse = JSON.parse(response.body);
            if (this.deleteUserResponse && this.deleteUserResponse.status == 'OK') {

              this.spinner.hide("sp1");

              this.toastr.successToastr('User deleted successfully!', 'User deleted result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.deleteUserResponse && this.deleteUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the delete user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {
          if (response && response.status) {
            this.deleteUserResponse = response;
            if (this.deleteUserResponse && this.deleteUserResponse.status == 'OK') {

              this.spinner.hide("sp1");

              this.toastr.successToastr('User deleted successfully!', 'User deleted result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.deleteUserResponse && this.deleteUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr('Error during the delete user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }

      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the delete user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          console.error(err);



        });

  }

  /**
   * Parse user data into the format required for the updateUtente API
   */
  parseUserDataForUpdate(userData: any) {
    return {
      username: userData.username || '',
      email: userData.email || '',
      phoneNumber: userData.phoneNumber || '',
      dataInsAsString: userData.dataInsAsString || '',
      dataModAsString: userData.dataModAsString || '',
      userGroups: Array.isArray(userData.userGroups) ? userData.userGroups : (userData.userGroups ? [userData.userGroups] : []),
      userCreate: userData.userCreate || '',
      userUpdate: userData.userUpdate || '',
      nome: userData.nome || '',
      cognome: userData.cognome || '',
      singleGroupUserFe: userData.singleGroupUserFe || '',
      firstLogin: userData.firstLogin || '',
      dataLastUpdatePassword: userData.dataLastUpdatePassword || ''
    };
  }

  updateUtente(elemToUpdate: any) {
    let dataUserUpdate: any = this.createUpdateUserDto(this.updateUtenteForm);
    const parsedUserData = this.parseUserDataForUpdate(elemToUpdate);

    let dataRest: any = {
      dataUserUpdated: dataUserUpdate,
      elementoDaModificare: parsedUserData
    }

    this.spinner.show("sp1");

    let urlUpdateUser: string = environment.basePath + _ENDPOINT.updateUserAttributes;


    let data = Utility.createBodyForPostRequest(dataRest);
    this.networkService.post(urlUpdateUser, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.updateUserResponse = JSON.parse(response.body);
            if (this.updateUserResponse && this.updateUserResponse.status == 'OK') {
              this.spinner.hide("sp1");
              this.toastr.successToastr('User update successfully!', 'User update result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.updateUserResponse && this.updateUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.updateUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the update user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {
          if (response && response.status) {
            this.updateUserResponse = response;
            if (this.updateUserResponse && this.updateUserResponse.status == 'OK') {
              this.spinner.hide("sp1");
              this.toastr.successToastr('User update successfully!', 'User update result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();


            } else if (this.updateUserResponse && this.updateUserResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.updateUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.loadListUsers();
              this.loadGroups();
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide("sp1");
            console.log(response);
            this.toastr.errorToastr('Error during the update user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the update user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          console.error(err);



        });

  }

  validaUpdateUtente(): boolean {
    let result = true;

    let regex = new RegExp(this.regexMail);
    if (!regex.test(this.updateUtenteForm.controls['mail'].value)) {
      this.toastr.errorToastr('Wrong email format!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });
      return false;
    }

    let regexPhone = new RegExp(this.regexPhoneNumber);
    if (!regexPhone.test(this.updateUtenteForm.controls['phoneNumber'].value)) {
      this.toastr.errorToastr('The phone number do not have the international format!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }
    return result;
  }

  updateFormDisabled() {
    return this.updateUtenteForm?.invalid;
  }

  groupDisabledForUpdate() {

    let user: string = this.securityService.getUsername();
    if (this.securityService.isUserAdmin() && this.userNameUpdateModal && this.userNameUpdateModal == user) {
      this.updateUtenteForm.controls['group'].disable();
    } else {
      this.updateUtenteForm.controls['group'].enable();
    }
  }

   createUpdateUserDto(userForm: FormGroup) {
      let loBillingIds = [];
      let boBillingIds = [];
      let flBillingIds = [];

      if (this.isNewRoleUpdate()){
        loBillingIds = userForm.controls['billingAccountLO'].value;
        boBillingIds = userForm.controls['billingAccount'].value
        flBillingIds = userForm.controls['billingAccountLO'].value;
      }
       let group = userForm.controls['group'].value
      if (group && (group === 'FLEET_MANAGER_ADMIN' || group === 'FLEET_MANAGER')) {
        boBillingIds = [];
      }else{
        flBillingIds = [];
      }
      return {
        nome: userForm.controls['nome'] ? userForm.controls['nome'].value : '',
        mail: userForm.controls['mail'] ? userForm.controls['mail'].value : '',
        cognome: userForm.controls['cognome'] ? userForm.controls['cognome'].value : '' ,
        userUpdate: this.securityService.getUsername(),
        phoneNumber: userForm.controls['phoneNumber'] ? userForm.controls['phoneNumber'].value : '',
        group: userForm.controls['group'] ? userForm.controls['group'].value : '',
        loBillingAccount: userForm.controls['billingAccountLO']
          ? (loBillingIds ? loBillingIds.join(',') : '')
          : '',
        boBillingAccount: userForm.controls['billingAccount']
          ? (boBillingIds ? boBillingIds.join(',') : '')
          : '',
        flBillingAccount: userForm.controls['billingAccountLO']
          ? (flBillingIds ? flBillingIds.join(',') : '')
          : '',
        operator: userForm.controls['operator'] ? userForm.controls['operator'].value : '',
        customerNames: userForm.controls['customer']
          ? Array.isArray(userForm.controls['customer'].value)
        ? userForm.controls['customer'].value.join(',')
        : userForm.controls['customer'].value || ''
          : '',
        customerIds: userForm.controls['customer']
          ? Array.isArray(userForm.controls['customer'].value)
        ? userForm.controls['customer'].value.join(',')
        : userForm.controls['customer'].value || ''
          : ''
      };
    }


  deleteDisabledForMyUser() {
    let user: any = this.securityService.getUser();
    if (this.securityService.isUserAdmin() && this.userToDelete && this.userToDelete == user) {
      return true;
    } else {
      return false;
    }
  }

  isUserAdmin() {
    return this.securityService.isUserAdmin();
  }

  changePasswordFormDisabled() {
    this.changePasswordForm?.invalid;
  }

  changePasswordEnabled() {
    let res: boolean = this.userNameUpdateModal == this.securityService.getUsername();
    return res;
  }

  openChangePasswordModal() {
    this.changePasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    });
    this.modalReference = this.modalService.open(this.changePasswordModal, { size: 'sm' });
    this.modalReference.result.then((result) => {

    }, (reason) => {

      /*Leave empty or handle reject*/

    });
  }

  confirmChange() {
    if (this.validaPassword()) {
      this.login();
    }
  }

  validaPassword() {
    let userLoginDto = {
      newpassword: this.changePasswordForm?.controls['newPassword'].value,
      repeatpassword: this.changePasswordForm?.controls['confirmPassword'].value,
    }

    let regexPass = new RegExp(this.regexPassword);
    if (!regexPass.test(userLoginDto.newpassword)) {
      this.toastr.errorToastr('The password must contain at least 8 characters, one uppercase character, one lowercase character, one number and one special character!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }

    if (userLoginDto.newpassword != userLoginDto.repeatpassword) {
      this.toastr.errorToastr('New Password and Repeat Password do not match!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });

      return false;
    }

    return true;
  }

  login(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      newPassword: this.changePasswordForm?.controls['newPassword'].value,
      username: this.securityService.getUsername(),

    }
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.resetPassword;
    this.networkService.post(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {

          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = JSON.parse(response.body);
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Reset Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.modalReferenceUpdateModal.close(false);
              this.modalReference.close();
              this.securityService.logout();
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.esito) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = response;
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Change Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.modalReferenceUpdateModal.close(false);
              this.modalReference.close();
              this.securityService.logout();
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        });;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  //white portal methods

  isFasAdmin(): boolean {
    let user: any = this.securityService.getGroupUser();
    return user && (user === 'FAS_ADMIN' || user === 'ADMIN_FREEMOVE_FE');
  }

  isNewRole(): boolean {
    let group = this.aggiungiUtenteForm.controls['group'].value
    return group && (group === 'BACK_OFFICE_ADMIN' || group === 'BACK_OFFICE_AGENT' || group === 'FLEET_MANAGER_ADMIN' || group === 'FLEET_MANAGER');
  }

  isNewRoleFleetManager(): boolean {
    let group = this.aggiungiUtenteForm.controls['group'].value
    return group && (group === 'FLEET_MANAGER_ADMIN' || group === 'FLEET_MANAGER');
  }

  isNewRoleUpdate(): boolean {
    let group = this.updateUtenteForm?.controls['group']?.value;
    return group && (group === 'BACK_OFFICE_ADMIN' || group === 'BACK_OFFICE_AGENT' || group === 'FLEET_MANAGER_ADMIN' || group === 'FLEET_MANAGER');
  }

  isNewRoleFleetManagerUpdate(): boolean {
    let group = this.updateUtenteForm?.controls['group']?.value;
    return group && (group === 'FLEET_MANAGER_ADMIN' || group === 'FLEET_MANAGER');
  }

  isNewRoleBackOffice(): boolean {
    let group = this.aggiungiUtenteForm.controls['group'].value
    return group && (group === 'BACK_OFFICE_ADMIN' || group === 'BACK_OFFICE_AGENT');
  }
  loadOperators() {
    this.listOperatorView = [
      { id: 'ORANGE', name: 'ORANGE' },
      { id: 'TIM', name: 'TIM' },
      { id: 'IMSA', name: 'DEUTSCHE TELEKOM' },
      { id: 'TELIA', name: 'TELIA' },
       { id: 'SWISSCOM', name: 'SWISSCOM' },
      { id: 'FREEMOVE' , name : 'FREEMOVE'}
    ];
  }

  onOperatorChange(event: any) {
    const operatorId = event.target.value;
    this.initializeListCustomer(operatorId);
  }

  initializeListCustomer(operatorId?: string) {
    this.spinner.show("sp1");
    const group = this.aggiungiUtenteForm.get('group')?.value;
    this.clearSelections();
    this.usersManagementService.GetUserBillingAccounts(this.aggiungiUtenteForm.get('group')?.value, operatorId || '')
      .subscribe((data) => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (data && data.statusCode == '200' && data.body && data.body.length > 0) {
            let parsed = JSON.parse(data.body)
            this.billingTableDataRecord = parsed.billingAccountsBO;
            this.billingTableLORecord = parsed.billingAccountsLO;
            this.listCustomerView = Object.keys(this.billingTableDataRecord || []).concat(Object.keys(this.billingTableLORecord || []));
            this.aggiungiUtenteForm.get('customer')?.enable();
            if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
              this.listCustomerView = [''].concat(this.listCustomerView);
            }
          } else {
            this.toastr.errorToastr('Error during Retrieve Users', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.spinner.hide("sp1");
          }
        } else {
          if (data) {
            this.billingTableDataRecord = data.billingAccountsBO;
            this.billingTableLORecord = data.billingAccountsLO;
            this.listCustomerView = Object.keys(this.billingTableDataRecord || []).concat(Object.keys(this.billingTableLORecord || []));
            if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
              this.listCustomerView = [''].concat(this.listCustomerView);
            }
            this.aggiungiUtenteForm.get('customer')?.enable();
          } else {
            this.toastr.errorToastr('Error retrieving billing accounts', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
        this.spinner.hide("sp1");

      },
        (err) => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error retrieving billing accounts', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        }
      );
  }

  onCustomerChange(event: any): void {
    const selectedCustomers = this.ensureArray(this.aggiungiUtenteForm.controls['customer'].value);

    if (selectedCustomers.length > 0) {
      this.initiliazeBillingTable(selectedCustomers);
    } else {
      this.billingTableData = [];
      this.billingTableLO = [];
    }

    this.aggiungiUtenteForm.get('billingAccount')?.reset();
    this.aggiungiUtenteForm.get('billingAccountLO')?.reset();
  }

  initiliazeBillingTable(ids: string[]): void {
    this.billingTableData = [];
    this.billingTableLO = [];
    if (!Array.isArray(ids)) {
      return;
    }
    ids.forEach(id => {
      if (this.billingTableDataRecord && this.billingTableDataRecord[id]) {
        this.billingTableData.push(...this.billingTableDataRecord[id]);
      }
      if (this.billingTableLORecord && this.billingTableLORecord[id]) {
        this.billingTableLO.push(...this.billingTableLORecord[id]);
      }
    });
  }

  onRoleSelectionChange(event: any) {
    let selectedRole = this.aggiungiUtenteForm.get('group')?.value;
    this.aggiungiUtenteForm.get('operator')?.reset();
    // Remove fields if present
    if (this.aggiungiUtenteForm.contains('operator')) {
      this.aggiungiUtenteForm.removeControl('operator');
    }
    if (this.aggiungiUtenteForm.contains('customer')) {
      this.aggiungiUtenteForm.removeControl('customer');
    }
    if (this.aggiungiUtenteForm.contains('billingAccountLO')) {
      this.aggiungiUtenteForm.removeControl('billingAccountLO');
    }
    if (this.aggiungiUtenteForm.contains('billingAccount')) {
      this.aggiungiUtenteForm.removeControl('billingAccount');
    }
    this.aggiungiUtenteForm.clearValidators();
    this.aggiungiUtenteForm.updateValueAndValidity();
    if (this.isNewRole()) {
      // Add fields if not present
      if (!this.aggiungiUtenteForm.contains('operator')) {
        this.aggiungiUtenteForm.addControl('operator', this.formBuilder.control('', Validators.required));
      }
      if (!this.aggiungiUtenteForm.contains('customer')) {
        this.aggiungiUtenteForm.addControl('customer', this.formBuilder.control('', Validators.required));
      }
      if (this.isNewRoleFleetManager()) {
        if (!this.aggiungiUtenteForm.contains('billingAccountLO')) {
          this.aggiungiUtenteForm.addControl('billingAccountLO', this.formBuilder.control([], Validators.required));
        }
        if (this.aggiungiUtenteForm.contains('billingAccount')) {
          this.aggiungiUtenteForm.removeControl('billingAccount');
        }
      } else if (this.isNewRoleBackOffice()) {
        if (!this.aggiungiUtenteForm.contains('billingAccountLO')) {
          this.aggiungiUtenteForm.addControl('billingAccountLO', this.formBuilder.control([]));
        }
        if (!this.aggiungiUtenteForm.contains('billingAccount')) {
          this.aggiungiUtenteForm.addControl('billingAccount', this.formBuilder.control([]));
        }
        // Custom validator for backoffice: at least one of billingAccount or billingAccountLO required
        this.aggiungiUtenteForm.setValidators(() => {
          const ba = this.aggiungiUtenteForm.get('billingAccount')?.value;
          const baLO = this.aggiungiUtenteForm.get('billingAccountLO')?.value;
          if ((ba && ba.length > 0) || (baLO && baLO.length > 0)) {
            return null;
          }
          return { billingRequired: true };
        });
        this.aggiungiUtenteForm.updateValueAndValidity();
      }
    }
    this.clearSelections();
  }

  // Helper for UI disabling
  isBillingRequiredInvalid(): boolean {
    return this.aggiungiUtenteForm.hasError('billingRequired');
  }

  clearSelections() {
    this.listCustomerView = [];
    this.billingTableData = [];
    this.billingTableLO = [];
    this.aggiungiUtenteForm.get('customer')?.reset();
    this.aggiungiUtenteForm.get('billingAccount')?.reset();
    this.aggiungiUtenteForm.get('billingAccountLO')?.reset();
  }

  onOperatorChangeUpdate(event: any) {
    const operatorId = event.target.value;
    this.initializeListCustomerUpdate(operatorId);
  }

  onCustomerChangeUpdate(): void {
    const selectedCustomers = this.ensureArray(this.updateUtenteForm.controls['customer'].value);

    if (selectedCustomers.length > 0) {
      this.initiliazeBillingTableUpdate(selectedCustomers);
    } else {
      this.billingTableData = [];
      this.billingTableLO = [];
    }

    this.updateUtenteForm.get('billingAccount')?.reset();
    this.updateUtenteForm.get('billingAccountLO')?.reset();
  }

  onRoleSelectionChangeUpdate(event: any) {
    let selectedRole = this.updateUtenteForm.get('group')?.value;
    this.updateUtenteForm.get('operator')?.reset();
    // Remove fields if present
    if (this.updateUtenteForm.contains('operator')) {
      this.updateUtenteForm.removeControl('operator');
    }
    if (this.updateUtenteForm.contains('customer')) {
      this.updateUtenteForm.removeControl('customer');
    }
    if (this.updateUtenteForm.contains('billingAccountLO')) {
      this.updateUtenteForm.removeControl('billingAccountLO');
    }
    if (this.updateUtenteForm.contains('billingAccount')) {
      this.updateUtenteForm.removeControl('billingAccount');
    }
    this.updateUtenteForm.clearValidators();
    this.updateUtenteForm.updateValueAndValidity();
    if (this.isNewRoleUpdate()) {
      // Add fields if not present
      if (!this.updateUtenteForm.contains('operator')) {
        this.updateUtenteForm.addControl('operator', this.formBuilder.control('', Validators.required));
      }
      if (!this.updateUtenteForm.contains('customer')) {
        this.updateUtenteForm.addControl('customer', this.formBuilder.control('', Validators.required));
      }
      if (this.isNewRoleFleetManager()) {
        if (!this.updateUtenteForm.contains('billingAccountLO')) {
          this.updateUtenteForm.addControl('billingAccountLO', this.formBuilder.control([], Validators.required));
        }
        if (this.updateUtenteForm.contains('billingAccount')) {
          this.updateUtenteForm.removeControl('billingAccount');
        }
      } else if (this.isNewRoleBackOffice()) {
        if (!this.updateUtenteForm.contains('billingAccountLO')) {
          this.updateUtenteForm.addControl('billingAccountLO', this.formBuilder.control([]));
        }
        if (!this.updateUtenteForm.contains('billingAccount')) {
          this.updateUtenteForm.addControl('billingAccount', this.formBuilder.control([]));
        }
        // Custom validator for backoffice: at least one of billingAccount or billingAccountLO required
        this.updateUtenteForm.setValidators(() => {
          const ba = this.updateUtenteForm.get('billingAccount')?.value;
          const baLO = this.updateUtenteForm.get('billingAccountLO')?.value;
          if ((ba && ba.length > 0) || (baLO && baLO.length > 0)) {
            return null;
          }
          return { billingRequired: true };
        });
        this.updateUtenteForm.updateValueAndValidity();
      }
    }
    this.clearSelectionsUpdate();
  }

  initializeListCustomerUpdate(operator?: string,   elemToUpdate?: any) {
    this.spinner.show("sp1");
    const group = this.updateUtenteForm.get('group')?.value;
    this.clearSelectionsUpdate();
    this.usersManagementService.GetUserBillingAccounts(this.updateUtenteForm.get('group')?.value, operator   || '')
      .subscribe((data) => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (data && data.statusCode == '200' && data.body && data.body.length > 0) {
            let parsed = JSON.parse(data.body)
            this.billingTableDataRecord = parsed.billingAccountsBO;
            this.billingTableLORecord = parsed.billingAccountsLO;
            this.listCustomerView = Object.keys(this.billingTableDataRecord || []).concat(Object.keys(this.billingTableLORecord || []));
            this.updateUtenteForm.get('customer')?.enable();
            if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
              this.listCustomerView = [''].concat(this.listCustomerView);
            }
            if (elemToUpdate) {
               this.updateUtenteForm.get('customer')?.setValue(elemToUpdate.customersId || '');
                this.onCustomerChangeUpdate()
                this.updateUtenteForm.get('billingAccount')?.setValue(elemToUpdate.boBillingAccounts || []);
                if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
                  this.updateUtenteForm.get('billingAccountLO')?.setValue(elemToUpdate.flBillingAccounts || []);
                }else{
                  this.updateUtenteForm.get('billingAccountLO')?.setValue(elemToUpdate.loBillingAccounts || []);
                }

              }else{
                 this.onCustomerChangeUpdate()
              }
          } else {
            this.toastr.errorToastr('Error during Retrieve Users', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
          this.spinner.hide("sp1");
        } else {

          ///siste
          if (data) {
            this.billingTableDataRecord = data.billingAccountsBO;
            this.billingTableLORecord = data.billingAccountsLO;
            this.listCustomerView = Object.keys(this.billingTableDataRecord || []).concat(Object.keys(this.billingTableLORecord || []));
            this.updateUtenteForm.get('customer')?.enable();
            if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
              this.listCustomerView = [''].concat(this.listCustomerView);
            }
            if (elemToUpdate) {
                this.updateUtenteForm.get('customer')?.setValue(elemToUpdate.customersId || '');
                this.onCustomerChangeUpdate()
                this.updateUtenteForm.get('billingAccount')?.setValue(elemToUpdate.boBillingAccounts || []);
                if (group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN') {
                  this.updateUtenteForm.get('billingAccountLO')?.setValue(elemToUpdate.flBillingAccounts || []);
                }else{
                  this.updateUtenteForm.get('billingAccountLO')?.setValue(elemToUpdate.loBillingAccounts || []);
                }
              }else{
                 this.onCustomerChangeUpdate()
              }
          } else {
            this.toastr.errorToastr('Error retrieving billing accounts', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
        this.spinner.hide("sp1");
      },
        (err) => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error retrieving billing accounts', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        }
      );
  }

  initiliazeBillingTableUpdate(ids: string[]): void {
    this.billingTableData = [];
    this.billingTableLO = [];
    if (!Array.isArray(ids)) {
      return;
    }
    ids.forEach(id => {
      if (this.billingTableDataRecord && this.billingTableDataRecord[id]) {
        this.billingTableData.push(...this.billingTableDataRecord[id]);
      }
      if (this.billingTableLORecord && this.billingTableLORecord[id]) {
        this.billingTableLO.push(...this.billingTableLORecord[id]);
      }
    });
  }

  clearSelectionsUpdate() {
    this.listCustomerView = [];
    this.billingTableData = [];
    this.billingTableLO = [];
    this.updateUtenteForm.get('customer')?.reset();
    this.updateUtenteForm.get('billingAccount')?.reset();
    this.updateUtenteForm.get('billingAccountLO')?.reset();
  }

  ensureArray(value: any): string[] {
    if (Array.isArray(value)) {
      return value.map((x: any) => String(x));
    }

    if (value === null || value === undefined || value === '') {
      return [];
    }

    if (typeof value === 'string' && value.includes(',')) {
      return value
        .split(',')
        .map((x: string) => x.trim())
        .filter((x: string) => !!x);
    }

    return [String(value)];
  }

  isSelected(form: FormGroup, controlName: string, value: string | number): boolean {
    const selected = this.ensureArray(form.get(controlName)?.value);
    return selected.includes(String(value));
  }

  toggleSelection(
    form: FormGroup,
    controlName: string,
    value: string | number,
    singleSelection: boolean = false
  ): void {
    const control = form.get(controlName);
    if (!control) {
      return;
    }

    const normalizedValue = String(value);
    let selected = this.ensureArray(control.value);

    if (singleSelection) {
      if (selected.includes(normalizedValue)) {
        selected = [];
      } else {
        selected = [normalizedValue];
      }
    } else {
      if (selected.includes(normalizedValue)) {
        selected = selected.filter((item: string) => item !== normalizedValue);
      } else {
        selected = [...selected, normalizedValue];
      }
    }

    control.setValue(selected);
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();

    this.handleSelectionDependencies(form, controlName);
  }

  selectAll(form: FormGroup, controlName: string, values: any[]): void {
    const control = form.get(controlName);
    if (!control) {
      return;
    }

    control.setValue(values.map((x: any) => String(x)));
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();

    this.handleSelectionDependencies(form, controlName);
  }

  clearAll(form: FormGroup, controlName: string): void {
    const control = form.get(controlName);
    if (!control) {
      return;
    }

    control.setValue([]);
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();

    this.handleSelectionDependencies(form, controlName);
  }

  getBillingIds(items: any[]): string[] {
    return (items || []).map((item: any) => String(item?.billingAccountId));
  }

  isSingleCustomerSelection(form: FormGroup): boolean {
    const group = form.get('group')?.value;
    return group === 'FLEET_MANAGER' || group === 'FLEET_MANAGER_ADMIN';
  }

  getSelectedCount(form: FormGroup, controlName: string): number {
    return this.ensureArray(form.get(controlName)?.value).length;
  }

  handleSelectionDependencies(form: FormGroup, controlName: string): void {
    if (controlName !== 'customer') {
      return;
    }

    if (form === this.aggiungiUtenteForm) {
      this.onCustomerChange(null);
      return;
    }

    if (form === this.updateUtenteForm) {
      this.onCustomerChangeUpdate();
    }
  }
}
